import { useSelector } from 'react-redux';

export const usePreferencia = key => {
  return useSelector(
    state => state.preferencias.preferencias[key]
  );
};